var render = function () {
  var _vm$product$title, _vm$product;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "ProductList",
      "extra-items": [{
        text: (_vm$product$title = (_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : _vm$product.title) !== null && _vm$product$title !== void 0 ? _vm$product$title : '',
        to: 'ProductDetailV2',
        params: _vm.$route.params.product_id
      }, '設定商品照片']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("設定商品照片")])])]), _vm.product != null ? _c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.product.title) + " ")]) : _vm._e(), _c('VueDraggable', {
    staticClass: "list-unstyled s-image-list mb-5",
    attrs: {
      "handle": ".s-draggable",
      "tag": "ul",
      "move": _vm.checkMove
    },
    model: {
      value: _vm.images,
      callback: function callback($$v) {
        _vm.images = $$v;
      },
      expression: "images"
    }
  }, [_vm._l(_vm.images, function (image, i) {
    return _c('li', {
      key: i,
      staticClass: "s-image-list-item s-draggable"
    }, [_c('img', {
      staticClass: "s-cropped-image",
      attrs: {
        "src": image
      }
    }), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.canClick,
        expression: "canClick"
      }],
      staticClass: "btn btn-danger s-delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteImage(i);
        },
        "touchstart": function touchstart($event) {
          return _vm.deleteImage(i);
        }
      }
    }, [_vm._v(" Ｘ ")])]);
  }), _vm.canUpload ? _c('li', {
    staticClass: "s-image-list-item",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('ImageSelector', {
    on: {
      "input": function input($event) {
        return _vm.images.push($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          attrs: {
            "disabled": !_vm.canClick
          },
          on: {
            "click": openFileSelector
          }
        }, [_vm.canClick ? [_c('div', {
          staticClass: "add-image-icon"
        }, [_vm._v("＋")]), _c('div', [_vm._v("新增")])] : [_vm._v(" 上傳中... ")]], 2)];
      }
    }], null, false, 1530662143)
  })], 1) : _vm._e()], 2), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.gotoProductList
    }
  }, [_vm._v("回商品列表")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }